import { AnyIfEmpty } from 'react-redux';
import { GET_AUTH_FAILURE, GET_AUTH_REQUEST, GET_AUTH_SUCCESS, RESET_VALIDATION_MESSAGE } from '../constants/auth.constant';
interface action {
    payload: AnyIfEmpty<object>;
    type: string;
}

const initialState = {
    loading: false,
    data: [],
    loginError: '',
};

const authReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case GET_AUTH_REQUEST:
            return {
                ...state,
                loading: true,
                loginError: '',
            };

        case GET_AUTH_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                loginError: '',
            };
        case GET_AUTH_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                loginError: action.payload,
            };
        case RESET_VALIDATION_MESSAGE:
            return {
                ...state,
                loading: false,
                data: [],
                loginError: '',
            };
        default:
            return state;
    }
};

export default authReducer;
